import { Text } from '@cencosud-cencommerce/paris-uikit';

import { getUserSessionData } from '@/Application/Hooks/GetCustomerData';
import { useAppSelector } from '@/Application/Hooks/Redux';
import { DeliveryInfoTemplate } from '@/modules/perseo-billing/containers/payment-complete/components/purchase-detail/deliveries';
import type { THomeDeliveryOrderConfirmation } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import type { IconTypes } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useCustomerContext } from '@/sections/customer/CustomerContext';

const MY_EMAIL = 'Mi correo electrónico:';
const SEND_DELIVERY_INFO =
  'Te enviaremos la fecha de entrega a tu correo electrónico.';

type HomeDeliveryInfoProps = {
  delivery: THomeDeliveryOrderConfirmation;
  deliveryIcon: IconTypes;
};

export const ScheduledDeferredInfo = (props: HomeDeliveryInfoProps) => {
  const order = useAppSelector((state) => state?.billing?.paymentSuccess);
  const { deliveryIcon } = props;

  const orderEmail = order?.customer.email;

  const { customer } = useCustomerContext();
  const sessionData = getUserSessionData();

  const customerEmail =
    orderEmail || sessionData?.email || customer.data?.email || '';

  const AdditionalInfo = () => {
    return (
      <div className="co-flex co-flex-col co-gap-4px co-px-16px">
        <Typography size="body2" weight="semibold">
          {MY_EMAIL}
        </Typography>
        <Typography size="body2">{customerEmail}</Typography>
      </div>
    );
  };

  return (
    <DeliveryInfoTemplate
      deliveryIcon={deliveryIcon}
      title={'Despacho'}
      additionalInfo={<AdditionalInfo />}
    >
      <Text
        color="neutral-800"
        variant="body2"
        weight={500}
        className="co-leading-[16px] co-text-[12px]"
      >
        {SEND_DELIVERY_INFO}
      </Text>
    </DeliveryInfoTemplate>
  );
};

ScheduledDeferredInfo.displayName = 'ScheduledDeferredInfo';

export default ScheduledDeferredInfo;
